import React from 'react';

export const Icons = () => {
  const iconArray = [
    'bff-approve',
    'bff-arrow-down-up',
    'bff-attention',
    'bff-bar-graph',
    'bff-bf-logo',
    'bff-bf-settings',
    'bff-brand-collective',
    'bff-build',
    'bff-calendar',
    'bff-chat',
    'bff-check-in',
    'bff-check-mark',
    'bff-check-out',
    'bff-clock',
    'bff-close',
    'bff-collapse',
    'bff-color-hexa',
    'bff-comment',
    'bff-confirmation',
    'bff-copy',
    'bff-credit-card',
    'bff-crop',
    'bff-cursor',
    'bff-custom-fields',
    'bff-arrow-up',
    'bff-down-arrow',
    'bff-download-asset',
    'bff-caret-up',
    'bff-dropdown-carrot',
    'bff-caret-right',
    'bff-edit-asset',
    'bff-edit',
    'bff-ellipses',
    'bff-email',
    'bff-embed',
    'bff-enter',
    'bff-eye',
    'bff-facebook-icon',
    'bff-facebook-icon-square',
    'bff-filters',
    'bff-font-type',
    'bff-full-screen',
    'bff-general-settings',
    'bff-grid-view',
    'bff-horizontal-orientation',
    'bff-insights',
    'bff-integrations',
    'bff-label',
    'bff-left-arrow',
    'bff-link',
    'bff-linked-in',
    'bff-linkedin-icon-square',
    'bff-list-view',
    'bff-location-marker',
    'bff-manage-subscription',
    'bff-manage-versions',
    'bff-merge',
    'bff-metadata',
    'bff-move',
    'bff-new-tab',
    'bff-notifications',
    'bff-panoramic-orientation',
    'bff-paperclip',
    'bff-payment',
    'bff-people',
    'bff-person',
    'bff-phone',
    'bff-pin',
    'bff-plus',
    'bff-print',
    'bff-private',
    'bff-public',
    'bff-quote-end',
    'bff-quote-start',
    'bff-ratio-lock',
    'bff-refresh',
    'bff-reorder',
    'bff-request-download',
    'bff-right-arrow',
    'bff-rules-engine',
    'bff-save',
    'bff-score-meter',
    'bff-search',
    'bff-share',
    'bff-square-orientation',
    'bff-star-hollow',
    'bff-star',
    'bff-stealth',
    'bff-tag',
    'bff-templating',
    'bff-tip',
    'bff-tool-tip',
    'bff-trash',
    'bff-twitter-icon',
    'bff-unapprove',
    'bff-unlink',
    'bff-upload',
    'bff-user-accepted',
    'bff-user-invited',
    'bff-vertical-orientation',
    'bff-visit-media',
    'bff-warning',
    'bff-you-tube-icon',
    'bff-zip-file',
    'bff-zoom-in',
    'bff-zoom-out',
  ];

  const buildIcons = () => (
    iconArray.map((el, i) => (
      <div className="icon-container" key={i}>
        <span className={`${el}`} />
        <h4 className="mls">{el}</h4>
      </div>
    ))
  );

  return (
    <div className="example-container icon-wrapper">
      {buildIcons()}
    </div>
  );
};

export default Icons;
